import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Modal from '@sdk/components/ui/modal/Modal';
import ModalFooterActionButtons from '@sdk/components/ui/modal/ModalFooterActionButtons';
import ModalBodyWithHeader from '@sdk/components/ui/modal/ModalBodyWithHeader';
import Text14 from '@sdk/components/ui/typography/Text14';
import Row from '@sdk/components/ui/spacing/Row';
import useAuth from '@sdk/authentication/useAuth';
import { ShouldShowElement } from '@sdk/authentication/types/apiTypes';

import { DontAskMeAgain } from '@web/components/DontAskMeAgain';
import DashboardBlueSvg from '@web/assets/svg/Icons/32/announcement-blue.svg';

import { DontAskMeAgainContainer } from './styles';

type Props = {
  about: ShouldShowElement;
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ProjectedSalesImportModal = ({ about, isVisible, onConfirm, onCancel }: Props) => {
  const { currentUser } = useAuth();

  return (
    <Modal isVisible={isVisible}>
      <ModalBodyWithHeader
        width={620}
        titleThemeColor={ThemeColorType.primary}
        titleText={gettext('Sync projected sales from Toast')}
        titleIcon={<DashboardBlueSvg />}
        close={onCancel}>
        <Row>
          <Text14 themeColor={ThemeColorType.gray}>
            {gettext('Are you sure you want to sync projected sales from Toast?')}{' '}
            {about === 'projectedSalesImportConfirmationOverride'
              ? gettext("It will overwrite any existing sales data on this week's schedule.")
              : null}
          </Text14>
        </Row>

        <DontAskMeAgainContainer>
          <DontAskMeAgain about={about} currentUser={currentUser} />
        </DontAskMeAgainContainer>

        <ModalFooterActionButtons
          cancel={onCancel}
          cancelText={gettext('Cancel')}
          submit={onConfirm}
          submitText={gettext('Sync')}
        />
      </ModalBodyWithHeader>
    </Modal>
  );
};
